import { Dropdown, Menu, MenuProps } from 'antd';
import React from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { CgProfile } from 'react-icons/cg';
import { FaUserCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import LoginActions from '../../../../login/redux/actions';

type ItemKeys = 'logout';

interface Items {
    key: ItemKeys;
    label: React.ReactNode;
    icon: React.ReactNode;
}

type Props = {
    isMobile?: boolean;
};

const AccountDropdown: React.FC<Props> = ({ isMobile }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const email = useSelector((state: RootState) => state.user.user?.email);

    const logout = () => {
        dispatch(LoginActions.removeUserData());
        return navigate(HEADERMENU_PATH.login);
    };

    const menuClick: MenuProps['onClick'] = (e) => {
        const key = e.key as ItemKeys;
        if (key === 'logout') {
            logout();
        }
    };

    const items: Items[] = [
        {
            key: 'logout',
            label: 'Logout',
            icon: <AiOutlineLogout className="text-lg mr-3 text-gray-700" size="1.2rem" />,
        },
    ];

    const menu = (
        <div className="bg-white py-2 px-4 shadow-2xl rounded-md">
            <div className="border-b-2 pb-3">
                <div className="flex flex-col justify-center items-center">
                    <CgProfile className="p-2" size="2.9rem" color="#c49a6d" />
                    <label className="text-base  font-[WorkSans-Semibold] ">{email}</label>
                </div>
            </div>
            <Menu className="border-0 header_menu" items={items} onClick={menuClick} />
        </div>
    );
    return (
        <Dropdown overlay={menu} placement="bottomRight" trigger={['click']} overlayClassName="common_dropdown">
            <FaUserCircle
                size="1.2rem"
                color={isMobile ? '#B1C1D4' : '#182D4F'}
                className="cursor-pointer ml-3"
                onClick={(e) => e.preventDefault()}
            />
        </Dropdown>
    );
};

export default AccountDropdown;
